import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, DatePicker, InputNumber } from "antd";
import "./Form.css";
import InputForm from "./InputForm";
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";

import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import GrupoFrame from './GrupoFrame';

import axios from "axios";

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Item: ItemForm } = Form;

export const OPCOES_COMBO_TIPO = [
  { key: 'X', label: 'Todos' },
  { key: 'P', label: 'Pedidos' },
  { key: 'O', label: 'Orçamentos' },
  { key: 'B', label: 'Bonificações' },
]

export const OPCOES_COMBO_ATIVIDADES = [
  { key: 'X', label: 'Todas as Atividades' },
  { key: 'E', label: 'Atividades Executadas' },
  { key: 'N', label: 'Atividades Não Executadas' },
]


export default class FiltrosDashBoardForm extends Component {
  state = {
    registroFiltros: {
      tipoTela: '',
      vendasDiaIni: '',
      vendasDiaFim: '',
      vendasMes: '',
      vendasAno: '',

      graficoVendasMeses: '',
      graficoMetasMeses: '',

      listaMelhoresClienteDataIni: '',
      listaMelhoresClienteDataFim: '',

      listaProdutosVendidoDataIni: '',
      listaProdutosVendidoDataFim: '',

      listaVendasGrupoDataIni: '',
      listaVendasGrupoDataFim: '',

      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaProduto: { key: '0' },
      buscaGrupoProduto: { key: '0' },
      buscaStatus: { key: '' },

      statusSelect: [],
    },
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.filtros !== propsAnterior.filtros) {
      // console.log('componentDidUpdate props: ', this.props.filtros);
      this.setState({
        registroFiltros: this.props.filtros,
      }, () => {

      });
    }
  }


  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
      buscaUsuario: {
        key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : usuario ? usuario.usu_cpf : '0'
      },
    }, this.getListaRegistros);
    this.buscaStatus();
  }



  onOK = () => {
    this.props.onFiltrarClick(this.state.registroFiltros);
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroFiltros } = this.state;
    registroFiltros[id] = value;
    this.setState({ [id]: value });
  };

  onChangePeriodo = event => {
    const { registroFiltros } = this.state;
    if (event[0]) {
      registroFiltros.buscaDataIni = moment(event[0]._d).format('DD/MM/YYYY');
      registroFiltros.buscaDataFim = moment(event[1]._d).format('DD/MM/YYYY');
    } else {
      registroFiltros.buscaDataIni = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY');
      registroFiltros.buscaDataFim = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY');
    }
    this.setState({
      registroFiltros
    },
      this.getListaRegistros
    );
  };

  onInputChangeMes = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaMes'] = event;
    this.setState(registroFiltros);
  }

  onInputChangeAno = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaAno'] = event;
    this.setState(registroFiltros);
  }

  onChangePessoa = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaPessoa'] = event.buscaPessoa;
    this.setState(event);
  }

  onChangeVendedor = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaUsuario'] = event.buscaUsuario;
    this.setState(event);
  }

  onChangeGrupo = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaGrupoProduto'] = event.buscaGrupoProduto;
    this.setState(event);
  }

  onChangeProduto = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaProduto'] = event.buscaProduto;
    this.setState(event);
  }


  buscaStatus = (value) => {
    this.setState({ statusSelect: [] })
    axios.get('/statusVenda/lista', {
    }).then(response => {
      const { data } = response;
      const statusSelect = data.map(regList => {
        return {
          key: regList.sv_idf,
          label: regList.sv_descricao,
          color: regList.sv_cor,
        }
      });
      this.setState({
        statusSelect,
      })
    }).catch(error => {
      console.error(error.response);
    })
  }


  onChangeStatus = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroFiltros } = this.state;
    registroFiltros['buscaStatus'] = value;
    this.setState({
      [id]: value
    });
  };




  render() {
    const { onCancelarFiltroClick, visivel } = this.props;
    const { tipoTela, buscaDataIni, buscaDataFim, buscaMes, buscaAno,
      buscaPessoa, buscaUsuario, buscaStatus, buscaGrupoProduto, buscaProduto } = this.state.registroFiltros;

    // console.log('FiltrosDashBoardForm.this.props: ', this.props);
    // console.log('FiltrosDashBoardForm.this.state: ', this.state);

    return (
      <Modal
        title={"Filtro"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarFiltroClick}
        footer={null}
        width={"25%"}
        style={{ top: 10 }}
      >

        <Row style={{ marginBottom: 40 }}>

          {tipoTela === 'XX' ? (
            <Col xs={24} style={{ marginTop: 10 }}>
              <span>Data</span>
              <InputForm
                type="date"
                id="buscaDataIni"
                ref="buscaDataIni"
                value={buscaDataIni}
                masker={maskDate}
                validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                dateFormat="DD/MM/YYYY"
                onChange={this.onChange}
                errorMessage="Formato correto DD/MM/AAAA"
                className="input-data-avaliacao"
                style={{ width: "100%" }}
              />
            </Col>
          ) : null}

          {tipoTela === 'VD' || tipoTela === 'LMC' || tipoTela === 'LPV' || tipoTela === 'LGP' || tipoTela === 'GVC' ? (
            <Col xs={24} style={{ marginTop: 10 }}>
              <span>Período</span>
              <RangePicker
                style={{ width: "100%" }}
                masker={maskDate}
                value={[moment(buscaDataIni, dateFormat), moment(buscaDataFim, dateFormat)]}
                format={dateFormat}
                onChange={this.onChangePeriodo}
              />
            </Col>
          ) : null}

          {tipoTela === 'VM' ? (
            <Col xs={24} style={{ marginTop: 10 }}>
              <Row>
                <span>Mês</span>
              </Row>
              <Row>
                <InputNumber
                  ref="Input"
                  id={buscaMes}
                  value={buscaMes}
                  onChange={this.onInputChangeMes}
                  min={1}
                  max={12}
                  maxLength={2}
                  style={{ width: "100%" }}
                />
              </Row>
            </Col>
          ) : null}

          {tipoTela === 'VM' || tipoTela === 'VA' || tipoTela === 'GVM' || tipoTela === 'GMM' ? (
            <Col xs={24} style={{ marginTop: 10 }}>
              <Row>
                <span>Ano</span>
              </Row>
              <Row>
                <InputNumber
                  ref="Input"
                  id={buscaAno}
                  value={buscaAno}
                  onChange={this.onInputChangeAno}
                  min={2020}
                  max={2100}
                  maxLength={4}
                  style={{ width: "100%" }}
                />
              </Row>
            </Col>
          ) : null}

          {tipoTela === 'PES' ? (
            <Col xs={24} style={{ marginTop: 10 }}>
              <PessoaFrame
                label="Cliente"
                id="buscaPessoa"
                value={buscaPessoa}
                width={"100%"}
                onChange={this.onChangePessoa}
                descricaoPrimeiroItem="Todos os Clientes"
              />
            </Col>
          ) : null}

          {tipoTela === 'USU' ? (
            <Col xs={24} style={{ marginTop: -20 }}>
              <UsuarioFrame
                label="Vendedor"
                id="buscaUsuario"
                value={buscaUsuario}
                todasEmpresas={this.state.usuario ? this.state.usuario.emp_codigo : 999999}
                width={"100%"}
                onChange={this.onChangeVendedor}
                descricaoPrimeiroItem="Todos os Vendedores"
                disabled={this.state.usuario && !getTemPermissao('UsuarioSupervisor', 'cons') ? true : false}
              />
            </Col>
          ) : null}


          {tipoTela === 'VD' || tipoTela === 'VM' || tipoTela === 'VA' || tipoTela === 'GVM' || tipoTela === 'GMM' || tipoTela === 'LMC' || tipoTela === 'LPV' || tipoTela === 'LGP' ? (
            <Col xs={24} style={{ marginTop: 10 }}>
              <Row>
                <span>Status</span>
              </Row>
              <InputForm
                type="select"
                id="buscaStatus"
                ref="buscaStatus"
                value={buscaStatus}
                placeholder="Status"
                onChange={this.onChangeStatus}
                data={this.state.statusSelect}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
              // style={{ width: 160, padding: 5, backgroundColor: registro.sv_cor ? registro.sv_cor : "#FFFFFF" }}
              />
            </Col>
          ) : null}



        </Row>

        <div>
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Filtrar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarFiltroClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FiltrosDashBoardForm.js